import request from '@/utils/request';
import * as types from '@/api/tags/types';

export function createTag(data: types.createTagReqType): Promise<types.createTagReqType> {
  return request({
    url: `/api/v2/projects/${data.repoId}/repository/tags`,
    method: 'post',
    data
  });
}

export function getTags(params: types.getTagsReqType): Promise<any> {
  const { order_by = '', sort = '' } = params;
  return request({
    url: `/api/v2/projects/${params.repoId}/repository/tags`,
    method: 'get',
    params: {
      order_by: order_by || types.TagSortType.COMMITED,
      sort: sort || 'desc',
      ...params
    }
  });
}

export function getTagDetail(params: types.tagDetailType): Promise<types.tagDetailType> {
  return request({
    url: `/api/v2/projects/${params.repoId}/repository/tags/${params.tag_name}`,
    method: 'get',
    params
  });
}

export function deleteTag(params: types.tagDetailType): Promise<types.tagDetailType> {
  return request({
    url: `/api/v2/projects/${params.repoId}/repository/tags/${params.tag_name}`,
    method: 'delete',
    params
  });
}

// 获取未发布版本的tag列表
export function getUnreleasedTags(params: types.tagDetailType): Promise<types.tagDetailType> {
  return request({
    url: `/api/v2/projects/${params.repoId}/releases/linktags`,
    method: 'get',
    params
  });
}

export function createTagAuth(project_path: string): Promise<any> {
  return request({
    url: `/api/v2/projects/get_create_tag_setting`,
    method: 'get',
    params: {
      project_path
    }
  });
}
